export const environment = {
    backendUrl: process.env.NODE_ENV === 'development' ? 'http://localhost:8080/' : 'https://backend.lektorat-kossmagk.de/',
}